import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComoros = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1876)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.9996 11.9653H10.9913C8.40861 14.548 6.84682 16.5419 5.25214 18.1366L12.0348 18.7478L22.5598 17.7044C23.4783 16.0077 24 14.0648 24 12C24 11.9884 23.9996 11.9769 23.9996 11.9653Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.25223 6.22613H22.5215C20.4807 2.51513 16.5343 0 12 0C8.6951 0 5.70279 1.33645 3.53271 3.498L5.25223 6.22613Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.77395 17.7043C4.69516 18.7831 4.27826 19.687 3.49774 20.4674C5.67063 22.6493 8.67743 24 12 24C16.5627 24 20.5303 21.4535 22.5599 17.7043H5.77395Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.51471 3.47995C-1.17157 8.16623 -1.17157 15.7642 3.51471 20.4506C5.45126 18.514 7.31374 16.6515 12 11.9653L3.51471 3.47995Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.16523 11.9653C3.16523 10.2169 4.39396 8.75633 6.03478 8.39802C5.78259 8.34294 5.52093 8.31308 5.25215 8.31308C3.23507 8.31308 1.59998 9.94817 1.59998 11.9653C1.59998 13.9823 3.23507 15.6174 5.25215 15.6174C5.52088 15.6174 5.78254 15.5876 6.03478 15.5325C4.39396 15.1741 3.16523 13.7136 3.16523 11.9653Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.99452 8.83481L6.18882 9.43265H6.81741L6.30882 9.80217L6.50312 10.4L5.99452 10.0305L5.48593 10.4L5.68022 9.80217L5.17163 9.43265H5.80022L5.99452 8.83481Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.99452 10.4L6.18882 10.9979H6.81741L6.30882 11.3674L6.50312 11.9652L5.99452 11.5957L5.48593 11.9652L5.68022 11.3674L5.17163 10.9979H5.80022L5.99452 10.4Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.99452 11.9652L6.18882 12.5631H6.81741L6.30882 12.9326L6.50312 13.5304L5.99452 13.1609L5.48593 13.5304L5.68022 12.9326L5.17163 12.5631H5.80022L5.99452 11.9652Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.99452 13.5305L6.18882 14.1283H6.81741L6.30882 14.4978L6.50312 15.0957L5.99452 14.7262L5.48593 15.0957L5.68022 14.4978L5.17163 14.1283H5.80022L5.99452 13.5305Z",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1876",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgComoros;
